import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Snackbar from '@material-ui/core/Snackbar';
import { notified } from '../redux/actions';
import SnacbarWrapper from './SnackbarWrapper';

function CustomizedSnackbars(props) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(false);
  const [type, setType] = useState('info');
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    if (props.notification) {
      const { message, type } = props.notification;
      setOpen(true);
      setMessage(message);
      setType(type);
      let duration;
      switch (type) {
        case 'error':
          duration = 30000;
          break;
        case 'off':
          duration = 1;
          break;
        default:
          duration = 6000;
      }
      setDuration(duration);
      props.notified();
    }
    // eslint-disable-next-line
  }, [props.notification]);

  const handleClose = (ev, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={open}
      autoHideDuration={duration}
      onClose={handleClose}
    >
      <SnacbarWrapper
        onClose={handleClose}
        variant={type}
        message={message}
      />
    </Snackbar>
  );
}

const mapStateToProps = (state) => {
  return { notification: state.notification }
}

export default connect(mapStateToProps, { notified })(CustomizedSnackbars)